import { regexPhoneNumberVN, regexNationalId, regexPassportNo, regexBusinessTaxCode } from '../../../../utils/regex';
import { BUYER_TYPE } from '../../../../app-constant';

export const customerInfoSchema = context => ({
  buyer_name: {
    label: context.$t('actions.form.buyer_name.label'),
    placeholder: context.$t('actions.form.buyer_name.placeholder'),
    type: 'input',
    disabled: () => context.isFieldDisabled('buyer_name'),
    asyncValidation(value, resolve, formData) {
      let result = true;
      const isDisabled = context.isFieldDisabled('buyer_name');
      if (!isDisabled && formData.buyer_type === BUYER_TYPE.PERSONAL && !formData.buyer_name) {
        result = { msg: context.$t('actions.form.buyer_name.validation.required') };
      }
      resolve(result);
    },
  },
  buyer_type: {
    label: context.$t('actions.form.buyer_type.label'),
    placeholder: context.$t('actions.form.buyer_type.placeholder'),
    type: 'select',
    disabled: () => context.isFieldDisabled('buyer_type'),
    options: context.buyerTypeOptions,
  },
  buyer_legal_name: {
    label: context.$t('actions.form.buyer_legal_name.label'),
    placeholder: context.$t('actions.form.buyer_legal_name.placeholder'),
    type: 'input',
    disabled: () => context.isFieldDisabled('buyer_legal_name'),
    asyncValidation(value, resolve, formData) {
      let result = true;
      const isDisabled = context.isFieldDisabled('buyer_legal_name');
      if (!isDisabled && formData.buyer_type === BUYER_TYPE.ENTERPRISE && !formData.buyer_legal_name) {
        result = { msg: context.$t('actions.form.buyer_legal_name.validation.required') };
      }
      resolve(result);
    },
  },
  buyer_taxcode: {
    label: context.$t('actions.form.buyer_taxcode.label'),
    placeholder: context.$t('actions.form.buyer_taxcode.placeholder'),
    type: 'input',
    disabled: () => context.isFieldDisabled('buyer_taxcode'),
    asyncValidation(value, resolve, formData) {
      let result = true;
      const isDisabled = context.isFieldDisabled('buyer_taxcode');
      if (!isDisabled && formData.buyer_type === BUYER_TYPE.ENTERPRISE) {
        if (!formData.buyer_taxcode) result = { msg: context.$t('actions.form.buyer_taxcode.validation.required') };
        else if (!regexBusinessTaxCode.test(formData.buyer_taxcode)) result = { msg: this.$t('error.form.taxCode.validate') };
      } else if (value) {
        if (value.company_TaxCode && !regexBusinessTaxCode.test(value.company_TaxCode)) {
          result = { msg: context.$t('error.form.taxCode.validate') };
        } else if (typeof value === 'string' && !regexBusinessTaxCode.test(`${value}`)) {
          result = { msg: context.$t('error.form.taxCode.validate') };
        }
      }
      resolve(result);
    },
  },
  buyer_address: {
    label: context.$t('actions.form.buyer_address.label'),
    placeholder: context.$t('actions.form.buyer_address.placeholder'),
    type: 'input',
    disabled: () => context.isFieldDisabled('buyer_address'),
    asyncValidation(value, resolve, formData) {
      let result = true;
      const isDisabled = context.isFieldDisabled('buyer_address');
      if (!isDisabled && formData.buyer_type === BUYER_TYPE.ENTERPRISE && !formData.buyer_address) {
        result = { msg: context.$t('actions.form.buyer_address.validation.required') };
      }
      resolve(result);
    },
  },
  buyer_email: {
    label: context.$t('actions.form.buyer_email.label'),
    placeholder: context.$t('actions.form.buyer_email.placeholder'),
    type: 'input',
    disabled: () => context.isFieldDisabled('buyer_email'),
    validation: { email: true },
  },
  buyer_phone_number: {
    label: context.$t('actions.form.buyer_phone_number.label'),
    placeholder: context.$t('actions.form.buyer_phone_number.placeholder'),
    type: 'input',
    disabled: () => context.isFieldDisabled('buyer_phone_number'),
    validation: { regex: regexPhoneNumberVN },
  },
  buyer_id_no: {
    label: context.$t('actions.form.buyer_id_no.label'),
    placeholder: context.$t('actions.form.buyer_id_no.placeholder'),
    type: 'input',
    disabled: () => context.isFieldDisabled('buyer_id_no'),
    validation: { regex: regexNationalId },
  },
  mdvqhnsach: {
    label: context.$t('actions.form.mdvqhnsach.label'),
    placeholder: context.$t('actions.form.mdvqhnsach.placeholder'),
    type: 'input',
    disabled: () => context.isFieldDisabled('mdvqhnsach'),
    validation: { max: 20 },
  },
  buyer_passport_no: {
    label: context.$t('actions.form.buyer_passport_no.label'),
    placeholder: context.$t('actions.form.buyer_passport_no.placeholder'),
    type: 'input',
    disabled: () => context.isFieldDisabled('buyer_passport_no'),
    validation: { regex: regexPassportNo },
  },
});

export const invoiceInfoSchema = context => ({
  invoice_type: {
    label: context.$t('actions.form.invoice_type.label'),
    placeholder: context.$t('actions.form.invoice_type.placeholder'),
    type: 'select',
    disabled: () => context.isFieldDisabled('invoice_type'),
    options: context.invoiceTypeOptions,
    validation: 'required',
  },
  template_code: {
    label: context.$t('actions.form.template_code.label'),
    placeholder: context.$t('actions.form.template_code.placeholder'),
    type: 'select',
    disabled: () => context.isFieldDisabled('template_code'),
    options: context.templateCodeOptions,
    validation: 'required',
  },
  invoice_number: {
    label: context.renderFieldType ? context.$t(`actions.form.${context.renderFieldType}.invoice_number.label`) : '',
    placeholder: context.renderFieldType ? context.$t(`actions.form.${context.renderFieldType}.invoice_number.placeholder`) : '',
    type: 'input',
    disabled: () => context.isFieldDisabled('invoice_number'),
    validation: 'required',
  },
  invoice_common_code: {
    label: context.$t('actions.form.invoice_common_code.label'),
    placeholder: context.$t('actions.form.invoice_common_code.placeholder'),
    type: 'select',
    disabled: () => context.isFieldDisabled('invoice_common_code'),
    options: context.commonCodeOptions,
    validation: 'required',
  },
  date_created: {
    label: context.$t('actions.form.date_created.label'),
    placeholder: context.$t('actions.form.date_created.placeholder'),
    type: 'datepicker',
    disabled: () => context.isFieldDisabled('date_created'),
  },
  payment_method: {
    label: context.$t('actions.form.payment_method.label'),
    placeholder: context.$t('actions.form.payment_method.placeholder'),
    type: 'select',
    disabled: () => context.isFieldDisabled('payment_method'),
    options: context.paymentMethodOptions,
    validation: 'required',
  },
  currency_code: {
    label: context.$t('actions.form.currency_code.label'),
    placeholder: context.$t('actions.form.currency_code.placeholder'),
    type: 'select',
    disabled: () => context.isFieldDisabled('currency_code'),
    options: context.currencyCodeOptions,
    validation: 'required',
  },
  foreign_rate: {
    label: context.$t('actions.form.foreign_rate.label'),
    placeholder: context.$t('actions.form.foreign_rate.placeholder'),
    type: 'currency',
    disabled: () => context.isFieldDisabled('foreign_rate'),
    display: () => context.showExchangeRate,
    fractionDigits: () => context.renderFractionDigitsForeignRate,
    asyncValidation(value, resolve, formData) {
      let result = true;

      if (formData.currency_code !== 'VND' && (!formData.foreign_rate || formData.foreign_rate === 'NaN')) {
        result = { msg: 'Tỷ giá là bắt buộc' };
      }
      resolve(result);
    },
    validation: 'required',
  },
});

export const deliveryInfoSchema = context => ({
  NBan_LDDNBo: {
    label: context.$t('actions.form.NBan_LDDNBo.label'),
    placeholder: context.$t('actions.form.NBan_LDDNBo.placeholder'),
    type: 'input',
    display: () => context.showDeliveryInfo,
    validation: 'required',
  },
  NBan_PTVChuyen: {
    label: context.$t('actions.form.NBan_PTVChuyen.label'),
    placeholder: context.$t('actions.form.NBan_PTVChuyen.placeholder'),
    type: 'input',
    display: () => context.showDeliveryInfo,
    validation: 'required',
  },
  NBan_HDSo: {
    label: context.$t('actions.form.NBan_HDSo.label'),
    placeholder: context.$t('actions.form.NBan_HDSo.placeholder'),
    type: 'input',
    display: () => context.showDeliveryInfo,
  },
  NBan_DChi: {
    label: context.$t('actions.form.NBan_DChi.label'),
    placeholder: context.$t('actions.form.NBan_DChi.placeholder'),
    type: 'input',
    display: () => context.showDeliveryInfo,
  },
  NBan_TNVChuyen: {
    label: context.$t('actions.form.NBan_TNVChuyen.label'),
    placeholder: context.$t('actions.form.NBan_TNVChuyen.placeholder'),
    type: 'input',
    display: () => context.showDeliveryInfo,
  },
  NBan_HVTNXHang: {
    label: context.$t('actions.form.NBan_HVTNXHang.label'),
    placeholder: context.$t('actions.form.NBan_HVTNXHang.placeholder'),
    type: 'input',
    display: () => context.showDeliveryInfo,
  },
});

export const additionalInfoSchema = context => ({
  note_change: {
    label: '',
    placeholder: '',
    type: 'textarea',
    display: false,
  },
  agreement_date: {
    label: context.renderFieldType ? context.$t(`actions.form.${context.renderFieldType}.agreement_date.label`) : '',
    placeholder: context.renderFieldType ? context.$t(`actions.form.${context.renderFieldType}.agreement_date.placeholder`) : '',
    type: 'datepicker',
    disabled: () => context.isFieldDisabled('agreement_date'),
    validation: context.isCancel ? 'required' : undefined,
  },
  reason_change: {
    label: context.renderFieldType ? context.$t(`actions.form.${context.renderFieldType}.reason_change.label`) : '',
    placeholder: context.renderFieldType ? context.$t(`actions.form.${context.renderFieldType}.reason_change.placeholder`) : '',
    type: 'textarea',
    rows: 1,
    disabled: () => context.isFieldDisabled('reason_change'),
    validation: 'required',
    notice: context.renderAttention,
  },
  evidence_for_change: {
    label: context.$t('actions.form.evidence_for_change.label'),
    placeholder: context.$t('actions.form.evidence_for_change.placeholder'),
    type: 'input',
    inputType: 'file',
    disabled: () => context.isFieldDisabled('evidence_for_change'),
  },
});

export const schema = context => ({
  ...customerInfoSchema(context),
  ...invoiceInfoSchema(context),
  ...deliveryInfoSchema(context),
  ...additionalInfoSchema(context),
});

export default schema;



// WEBPACK FOOTER //
// ./src/portal-components/invoice/actions-invoice/form-configs/schema.js